import React from "react";
import Modal from 'react-bootstrap/Modal';
import { formatCurrency } from "../../libs/utils";

const PlanDetailsModal = ({ show, plan, onClose }) => {

  return (
    <Modal
      show={show}
      onHide={onClose}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="contribution-modal"
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Plan Details
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="d-flex flex-column justify-content-left align-content-left p-4">
          <span>
            <div className="td-left">Employee Discount</div>
            <div className="td-right">
              {plan?.employeeDiscount}%
        </div>
          </span>

          <span>
            <div className="td-left">Offering Period</div>
            <div className="td-right">
              {plan?.lookBack} Months
        </div>
          </span>

          <span>
            <div className="td-left">Purchase Period</div>
            <div className="td-right">
              {plan?.purchasePeriod} Months
        </div>
          </span>

          <span>
            <div className="td-left">Increases Allowed</div>
            <div className="td-right">
              {plan?.increasesAllowed}
            </div>
          </span>

          <span>
            <div className="td-left">Decreases Allowed</div>
            <div className="td-right">
              {plan?.decreasesAllowed}
            </div>
          </span>

          <span>
            <div className="td-left">Minimum Stock Amount</div>
            <div className="td-right">
              {plan.minContribution.stock ? plan.minContribution.stock : "No Limit"}
            </div>
          </span>

          <span>
            <div className="td-left">Maximum Stock Amount</div>
            <div className="td-right">
              {plan.maxContribution.stock ? plan.maxContribution.stock : "No Limit"}
            </div>
          </span>

          <span>
            <div className="td-left">Minimum Dollar Contribution Amount</div>
            <div className="td-right">
              {plan.minContribution.dollar ? formatCurrency(plan.minContribution.dollar) : "No Limit"}
            </div>
          </span>

          <span>
            <div className="td-left">Maximum Dollar Contribution Amount</div>
            <div className="td-right">
              {formatCurrency(plan.maxContribution?.dollar)}
            </div>
          </span>

          <span>
            <div className="td-left">Minimum Percent Amount</div>
            <div className="td-right">
              {plan.minContribution.percent ? `${plan.minContribution.percent}%` : ""}
            </div>
          </span>

          <span>
            <div className="td-left">Maximum Percent Amount</div>
            <div className="td-right">
              {plan.maxContribution.percent ? `${plan.maxContribution.percent}%` : ""}
            </div>
          </span>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default PlanDetailsModal;
